export default {
  onboardingAndListingsNotCreated: {
    id: 'bo_seller.options.shipping.onboarding_and_listings_not_created',
    defaultMessage:
      'You need to create a listing before you can add shipping rules.',
  },
  errorTitle: {
    id: 'bo_seller.listings.actions.error_title',
    defaultMessage: 'Oops!',
  },
  fetchListingsErrorContent: {
    id: 'bo_seller.listings.actions.fetch_listings_error_content',
    defaultMessage: 'Failed to fetch listings. Please try again.',
  },
} as const
